import React from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "antd";

import { PatientOrderInfo } from "./PatientOrderInfo";
import { PatientProgramInfo } from "./PatientProgramInfo";
import { PatientDrugInfo } from "./PatientDrugInfo";
import { selectSelectedOrder } from "../store/selector";

const PatientCurrentCycleTab = ({ patient, setEdited }) => {
  const selectedOrder = useSelector(selectSelectedOrder);

  const displayOrder = selectedOrder || patient.currentOrder;

  const { potentialSaving } = patient;
  const { assistanceProgram, applicationStateJson, applicationId } = potentialSaving;

  return (
    <Row>
      <Col span={13} style={{ borderRight: "1px solid #DADADA", paddingRight: "12px" }}>
        <PatientOrderInfo patient={patient} setEdited={setEdited} />
      </Col>
      <Col span={6} style={{ borderRight: "1px solid #DADADA" }}>
        <PatientDrugInfo patient={patient} order={displayOrder} setEdited={setEdited} />
      </Col>
      <Col span={5}>
        <PatientProgramInfo
          assistanceProgram={assistanceProgram}
          applicationId={applicationId}
          applicationStateJson={applicationStateJson}
        />
      </Col>
    </Row>
  );
};

export { PatientCurrentCycleTab };
